import { Status } from './status';

export class Company {
  id: number = 0;
  code: string = '';
  name: string = '';
  businessName: string = '';
  status: Status = new Status();
  createdAt: Date = new Date();
  updatedAt: Date;
}
